import { __assign, __read } from "tslib";
/** @jsx jsx */
import { jsx } from '@emotion/core';
import { useState } from 'react';
import Item from '@atlaskit/item';
import DropList from '@atlaskit/droplist';
import Button, { ButtonGroup } from '@atlaskit/button';
import { Action } from './Action';
import { gs } from '../utils';
export var ActionList = function (_a) {
    var items = _a.items;
    var _b = __read(useState(false), 2), isOpen = _b[0], setOpen = _b[1];
    var actionsToShow = items.slice(0, 2);
    var actionsToList = items.slice(2, items.length);
    return (jsx("div", { css: { display: 'flex' } },
        jsx(ButtonGroup, null, actionsToShow.map(function (action) { return (jsx(Action, __assign({ key: action.id }, action))); })),
        actionsToList.length ? (jsx("div", { css: { marginLeft: gs(0.5) } },
            jsx(DropList, { appearance: "default", position: "right top", isTriggerNotTabbable: true, onOpenChange: function () { return setOpen(true); }, onClick: function () { return setOpen(!isOpen); }, isOpen: isOpen, trigger: jsx(Button, { spacing: "compact" }, "...") }, actionsToList.map(function (actionToList) { return (jsx(Item, { key: actionToList.id }, actionToList.text)); })))) : null));
};
//# sourceMappingURL=ActionList.js.map